export default __webpack_public_path__ + "static/expand-business-mobile-f0dc0016aba905b4b4afad07b2291d32.jpg";